<template>
  <div>
    <div
      class="popoutCard"
      :class="{
        hide:
          !selected &&
          (!infoBlurb.value || !infoBlurb.routeNames.includes($route.name)),
        inactive:
          !selected ||
          !infoBlurb.value ||
          !infoBlurb.routeNames.includes($route.name),
      }"
      :style="`background: ${selected ? colors[selected] : colors['help']}`"
    >
      <div class="popoutColumnSelector">
        <div
          v-if="false"
          class="selectorCard cursor-pointer q-mb-xs"
          :style="`background: ${colors['help']}`"
          @click="selected = selected == 'help' ? null : 'help'"
        >
          <q-icon
            style="margin: auto"
            class="text-white"
            name="mdi-help-circle"
            size="sm"
          ></q-icon>
        </div>
        <div
          v-if="infoBlurb.value && infoBlurb.routeNames.includes($route.name)"
          class="selectorCard cursor-pointer q-mb-xs"
          :style="`background: ${colors['info']}`"
          @click="selected = selected == 'info' ? null : 'info'"
        >
          <q-icon
            style="margin: auto"
            name="mdi-information"
            size="sm"
            class="text-primary"
          ></q-icon>
        </div>
      </div>
      <div
        v-if="
          selected == 'info' &&
          infoBlurb.value &&
          infoBlurb.routeNames.includes($route.name)
        "
        class="text-white"
      >
        <q-scroll-area
          :thumb-style="{
            background: '#162c479c',
            opacity: 1,
            width: '8px',
            height: '8px',
            borderRadius: '20px',
          }"
          style="height: 380px"
        >
          <div
            class="q-pa-md"
            v-html="infoBlurb.value"
            style="color: white"
          ></div>
        </q-scroll-area>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    computed: {
      ...mapGetters({
        infoBlurb: "settings/infoBlurb",
      }),
    },
    props: {},
    watch: {
      infoBlurb() {
        if (!this.infoBlurb.value) {
          this.selected = false;
        }
      },
    },
    data: () => ({
      colors: {
        help: "#64768C",
        info: "#1C3452",
      },
      selected: null,
    }),
    mounted() {},
    methods: {},
  };
</script>

<style lang="scss" scoped>
  .popoutCard {
    position: fixed;
    min-width: 310px;
    min-height: 400px;
    max-width: 310px;
    max-height: 400px;
    z-index: 9999;
    right: 0px;
    top: 70px;
    transition: 0.2s ease-out;
    -webkit-transition: 0.2s ease-out;
    -moz-transition: 0.2s ease-out;

    .popoutColumnSelector {
      position: absolute;
      min-width: 45px;
      min-height: 400px;
      max-width: 45px;
      max-height: 400px;
      left: -45px;

      .selectorCard {
        min-width: 45px;
        min-height: 45px;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        display: flex;
        align-items: center;
      }
    }
  }
  .inactive {
    right: -310px;
  }

  .hide {
    display: none;
  }
</style>
